const e = "styles-module__container___9oCr3", t = "styles-module__clickable___d24U9", _ = "styles-module__hideMobile___5q9Ty", o = "styles-module__rowButton___RwbDL", l = "styles-module__timestamp___zHSYY", s = "styles-module__newDot___aFF4S", n = "styles-module__detailsContainer___d9-fZ", a = "styles-module__lawyerName___aH7oi", d = "styles-module__prematterName___-6C-T", m = "styles-module__buttonLabel___6rGUC", i = "styles-module__ended___3Wuvq", c = {
  container: e,
  clickable: t,
  hideMobile: _,
  rowButton: o,
  timestamp: l,
  newDot: s,
  detailsContainer: n,
  lawyerName: a,
  prematterName: d,
  buttonLabel: m,
  ended: i
};
export {
  m as buttonLabel,
  t as clickable,
  e as container,
  c as default,
  n as detailsContainer,
  i as ended,
  _ as hideMobile,
  a as lawyerName,
  s as newDot,
  d as prematterName,
  o as rowButton,
  l as timestamp
};
